export function convertCommaSeperatedStringToArrayOfStrings(
  commaSeperatedCrewNames
) {
  return String(commaSeperatedCrewNames)
    .split(",")
    .map(crewNames => crewNames.trim())
    .filter(crewName => crewName.length > 0);
}
